if (!customElements.get('share-button')) {
  customElements.define(
    'share-button',
    class ShareButton extends DetailsDisclosure {
      constructor() {
        super();

        this.elements = {
          shareButton: this.querySelector('button'),
          shareSummary: this.querySelector('summary'),
          closeButton: this.querySelector('.share-button__close'),
          successMessage: this.querySelector('[id^="ShareMessage"]'),
          urlInput: this.querySelector('input'),
          errorMessage: this.querySelector('.share-button__error'),
        };
        this.urlToShare = this.elements.urlInput
          ? this.elements.urlInput.value
          : document.location.href;

        if (navigator.share) {
          this.mainDetailsToggle.setAttribute('hidden', '');
          this.elements.shareButton.classList.remove('hidden');
          this.elements.shareButton.addEventListener(
            'click',
            this.share.bind(this),
          );
        }
        this.mainDetailsToggle.addEventListener(
          'toggle',
          this.toggleDetails.bind(this),
        );
        this.mainDetailsToggle
          .querySelector('.share-button__copy')
          .addEventListener('click', this.copyToClipboard.bind(this));
        this.mainDetailsToggle
          .querySelector('.share-button__close')
          .addEventListener('click', this.close.bind(this));
      }

      async share() {
        this.clearError();
        try {
          await navigator.share({
            url: this.urlToShare,
            title: document.title,
          });
        } catch (error) {
          if (error?.name === 'AbortError') return;
          this.mainDetailsToggle.removeAttribute('hidden');
          this.elements.shareButton.classList.add('hidden');
          this.mainDetailsToggle.open = true;
          this.elements.shareSummary.setAttribute('aria-expanded', 'true');
          this.showError(this.dataset.shareError);
          this.elements.urlInput.focus();
        }
      }

      clearError() {
        this.elements.errorMessage?.classList.add('hidden');
        if (this.elements.errorMessage)
          this.elements.errorMessage.textContent = '';
      }

      showError(message) {
        if (!this.elements.errorMessage) return;
        this.elements.errorMessage.textContent = message;
        this.elements.errorMessage.classList.remove('hidden');
      }

      toggleDetails() {
        if (!this.mainDetailsToggle.open) {
          this.clearError();
          this.elements.successMessage.classList.add('hidden');
          this.elements.successMessage.textContent = '';
          this.elements.closeButton.classList.add('hidden');
          this.elements.shareSummary.focus();
        }
      }

      async copyToClipboard() {
        this.clearError();
        try {
          await navigator.clipboard.writeText(this.elements.urlInput.value);
          this.elements.successMessage.classList.remove('hidden');
          this.elements.successMessage.textContent =
            window.accessibilityStrings.shareSuccess;
          this.elements.closeButton.classList.remove('hidden');
          this.elements.closeButton.focus();
        } catch {
          this.showError(this.dataset.copyError);
          this.elements.urlInput.focus();
        }
      }

      updateUrl(url) {
        this.urlToShare = url;
        this.elements.urlInput.value = url;
      }
    },
  );
}
